import { Injectable } from '@angular/core';
import { UnitsService, Quantity,Gas, Pipe } from 'pumpcalc-core';
import { Keys, Labels } from '../app/gasflow.constants'

@Injectable({
  providedIn: 'root'
})
//expects all relevant values to be in SI
export class ValidationService {

  constructor(private unitsService: UnitsService) { }

  validateCalculation(pipes: Pipe[], gas: Gas, gasTemperature:number, conditions: any, rangeVariables: any): { valid: boolean; errors: any } {
    let errors = {};
    return { valid: this.or([this.validConditions(conditions, errors), this.validGas(gas, gasTemperature, errors), this.validPipes(pipes, errors), this.validRangeVariables(rangeVariables, errors)]), errors: errors }
  }

  or(values: boolean[]) {
    let result = true;
    values.forEach(value => {
      if (!value) { result = false; }
    })
    return result;
  }

  validGas(gas, gasTemperature,errors): boolean {
    if (!gas || !gas.id) {
      errors[Keys.gasSection] = "Gas required";
      return false;
    }
    if(gasTemperature < 0) {
      errors[Keys.gasSection] = "Invalid Parameters";
      errors[Keys.gasEntryTemperature] = " Temperature must be greater than Absolute Zero " + this.unitsService.convertFromSIForQuantity(Quantity.TEMPERATURE,0) + " " + this.unitsService.getSelectedUnitForQuantity(Quantity.TEMPERATURE);
      return false;
    }
    return true;
  }

  validConditions(conditions, errors): boolean {
    let boundaryError = false;
    if (Object.keys(conditions).length == 0) {
      errors[Keys.boundaryConditionsSection] = "Boundary conditions required";
      return false;
    }
    Object.keys(conditions).forEach(rangeVariable => {
      errors[rangeVariable] = conditions[rangeVariable].value <= 0 ? Labels[rangeVariable] + " must be greater than zero" : null;
      boundaryError = boundaryError || conditions[rangeVariable].value <= 0 ? true : false;
    })
    errors[Keys.boundaryConditionsSection] = boundaryError ? "Invalid parameters" : null;
    return !boundaryError;
  }

  validPipes(pipes: Pipe[], errors): boolean {
    let validPipes = true;
    let pipeWorkErrors = [];
    pipes.forEach(function (pipe, index) {
      let validPipe = this.validPipe(pipe, errors, pipeWorkErrors, index);
      validPipes = !validPipes ? validPipes : validPipe;
    }.bind(this))
    errors[Keys.pipeWorkSection] = validPipes ? null : "Invalid parameters";
    errors[Keys.pipeWorkErrors] = pipeWorkErrors;
    return validPipes;
  }

  validPipe(pipe, errors, pipeWorkErrors: any[], rowIndex): boolean {
    let pipeError = false;
    switch (pipe.section) {
      case Labels[Keys.circular]:
        errors[Labels[Keys.diameter]] = pipe.xdim1 <= 0 ? Labels[Keys.diameter] + " must be greater than 0" : null;
        if (errors[Labels[Keys.diameter]]) { pipeWorkErrors.push(this.pipeError(rowIndex, "xdim1", "xdim1 must be greater than zero")); }
        pipeError = pipeError || errors[Labels[Keys.diameter]] ? true : false;
        ; break;
      case Labels[Keys.annular]:
        errors[Labels[Keys.radialGap]] = pipe.xdim2 <= 0 ? Labels[Keys.radialGap] + " must be greater than 0" : null;
        errors[Labels[Keys.insideDiameter]] = pipe.xdim1 <= 0 ? Labels[Keys.insideDiameter] + " must be greater than 0" : null;
        if (errors[Labels[Keys.radialGap]]) { pipeWorkErrors.push(this.pipeError(rowIndex, "xdim2", "xdim2 must be greater than zero")); }
        if (errors[Labels[Keys.insideDiameter]]) { pipeWorkErrors.push(this.pipeError(rowIndex, "xdim1", "xdim1 must be greater than zero")); }
        pipeError = pipeError || errors[Labels[Keys.radialGap]] || errors[Labels[Keys.insideDiameter]] ? true : false;
        ; break;
      case Labels[Keys.rectangular]:
        errors[Labels[Keys.width]] = pipe.xdim1 <= 0 ? Labels[Keys.width] + " must be greater than 0" : null;
        errors[Labels[Keys.height]] = pipe.xdim2 <= 0 ? Labels[Keys.height] + " must be greater than 0" : null;
        if (errors[Labels[Keys.width]]) { pipeWorkErrors.push(this.pipeError(rowIndex, "xdim1", "xdim1 must be greater than zero")); }
        if (errors[Labels[Keys.height]]) { pipeWorkErrors.push(this.pipeError(rowIndex, "xdim2", "xdim2 must be greater than zero")); }
        pipeError = pipeError || errors[Labels[Keys.width]] || errors[Labels[Keys.height]] ? true : false;
        ; break;
    }
    errors[Labels[Keys.length]] = pipe.length < 0 ? Labels[Keys.length] + " must be zero or greater" : null;
    if (errors[Labels[Keys.length]]) { pipeWorkErrors.push(this.pipeError(rowIndex, "length", "length must be zero or greater")); }
    errors[Labels[Keys.bends]] = pipe.bends < 0 ? Labels[Keys.bends] + " must be zero or greater" : null;
    if (errors[Labels[Keys.bends]]) { pipeWorkErrors.push(this.pipeError(rowIndex, "bends", "bends must be zero or greater")); }
    errors[Labels[Keys.numberInParallel]] = pipe.parallel <= 0 ? Labels[Keys.numberInParallel] + " must be greater than 0" : null;
    if (errors[Labels[Keys.numberInParallel]]) { pipeWorkErrors.push(this.pipeError(rowIndex, "parallel", "parallel must be greater than zero")); }
    return !pipeError;
  }

  pipeError(rowIndex, dataField, message) {
    return { rowIndex: rowIndex, message: message, dataField: dataField, level: 1 };
  }

  validRangeVariables(rangeVariables: any, errors): boolean {
    let result = true;
    Object.keys(rangeVariables).forEach(rangeVariable => {

      if (!rangeVariables[rangeVariable].key) { result=false;}
      if (rangeVariables[rangeVariable].intervals <= 0 || rangeVariables[rangeVariable].intervals >= 100) { errors["range" + rangeVariable + Keys.intervals] = "Intervals must be between 0 to 99"; result = false; }
      if (rangeVariables[rangeVariable].key == "length" || rangeVariables[rangeVariable].key == "bends") {
        if (rangeVariables[rangeVariable].min < 0) { errors["range" + rangeVariable + Keys.min] = Labels[Keys.min] + " must be greater than equal to zero"; result = false; }
      }
      else {
        if (rangeVariables[rangeVariable].min <= 0)
            { errors["range" + rangeVariable + Keys.min] = Labels[Keys.min] + " must be greater than " +(rangeVariables[rangeVariable].quantity == Quantity.TEMPERATURE?" Absolute Zero " + this.unitsService.convertFromSIForQuantity(Quantity.TEMPERATURE,0) + " " + this.unitsService.getSelectedUnitForQuantity(Quantity.TEMPERATURE):"zero"); result = false; }
      }
      if (rangeVariables[rangeVariable].max <= 0) { errors["range" + rangeVariable + Keys.max] = Labels[Keys.max] + " must be greater than zero"; result = false; }
      if (rangeVariables[rangeVariable].max <= rangeVariables[rangeVariable].min) { errors["range" + rangeVariable + Keys.max] = Labels[Keys.max] + " must be greater than " + Labels[Keys.min]; result = false; }
    })
    if ((rangeVariables[1] ? rangeVariables[2] ? rangeVariables[1].rangeVariable == rangeVariables[2].rangeVariable : false : false)) {
      errors["range2" + Keys.variable] = Labels[Keys.variable] + " must be different to Variable 1"; result = false;
    }
    if (!result) { errors[Keys.rangeOnVariableSection] = "Invalid parameters" }
    return result;
  }

}


